<!-- pb-nav-safe reserves the mobile bottom-nav's height (+ home-indicator inset)
     under the last thing on the page, so nothing is ever trapped behind the bar. -->
<footer class="w-full bg-[#0a0a0a] border-t border-gray-800/50 py-6 pb-nav-safe sm:pb-6 text-center">
  <p class="text-xs text-gray-500">
    Made with <span class="text-red-400">&#10084;</span> as a hobby project
    <span class="mx-1">&middot;</span>
    <a routerLink="/about" class="hover:text-gray-300 transition-colors">About</a>
    <span class="mx-1">&middot;</span>
    <a routerLink="/terms" class="hover:text-gray-300 transition-colors">Terms</a>
  </p>
  <p class="text-xs text-gray-600 mt-1">
    &copy; 2024–{{ currentYear }} Stream Fiesta
  </p>
</footer>
